import { environment } from "src/environments/environment";

export class ServiceBase {
    private _serviceOrigin: string;
    constructor(private serviceOrigin: string) {
        this._serviceOrigin = serviceOrigin;
    }
    get url(): string {
        let url = environment.microServices.origin;
        return `${url}${environment.microServices[this.serviceOrigin]}`;
    }
}
